import { useCallback } from "react";
import "../external/react-dom/test-utils.js";
const getErrorMessage = (errorMsg, messageMap) => {
  if (!errorMsg) return void 0;
  return (messageMap == null ? void 0 : messageMap[errorMsg]) ?? errorMsg;
};
const showToastError = (toast, error2, options) => {
  var _a, _b, _c, _d;
  const { defaultErrorMessage, errorMessageMap, errorMessageResolver, toastRenderer } = options;
  let resolved;
  if (errorMessageResolver) {
    const result = errorMessageResolver(error2);
    if (result) {
      if (typeof result === "object" && result.message !== void 0) {
        resolved = result;
      } else {
        resolved = { message: result };
      }
    }
  }
  if (!resolved) {
    let message2 = defaultErrorMessage ?? "";
    if ((_b = (_a = error2 == null ? void 0 : error2.data) == null ? void 0 : _a.error) == null ? void 0 : _b.errors) {
      let counter = 0;
      let firstMessage = "";
      for (const k in error2.data.error.errors) {
        if (counter === 0) {
          firstMessage = error2.data.error.errors[k].message ?? ((_c = error2.data.error.errors[k]) == null ? void 0 : _c.msg) ?? error2.data.error.message ?? "validation error";
        }
        counter++;
      }
      message2 = `${getErrorMessage(firstMessage, errorMessageMap)} ${counter > 1 ? `(+${counter - 1})` : ""}`;
    } else {
      message2 = getErrorMessage((_d = error2 == null ? void 0 : error2.data) == null ? void 0 : _d.error.message, errorMessageMap) ?? message2;
    }
    resolved = { message: message2 };
  }
  const { message, duration, toastId, useCustomRenderer } = resolved;
  const toastOptions = {};
  if (toastId) {
    toastOptions.id = toastId;
  }
  if (duration) {
    toastOptions.duration = duration;
  }
  if (toastRenderer && useCustomRenderer) {
    const toastContent = (t) => {
      const props = { t, message, toastId: toastId || t.id };
      return toastRenderer(props);
    };
    toast == null ? void 0 : toast.error(toastContent, toastOptions);
  } else {
    toast == null ? void 0 : toast.error(message, toastOptions);
  }
};
function useHandleApiResponse(hookOptions) {
  const handleApiResponse = useCallback(
    (result, options) => {
      const {
        toastError = true,
        toastSuccess = true,
        defaultErrorMessage,
        onError,
        errorMessageMap,
        successMessage,
        onSuccess,
        redirect,
        errorMessageResolver,
        toastRenderer
      } = options ?? {};
      const { toast, navigate } = hookOptions ?? {};
      if ("data" in result) {
        if (toastSuccess) {
          successMessage && (toast == null ? void 0 : toast.success(successMessage));
        }
        onSuccess == null ? void 0 : onSuccess(result.data);
        redirect && (navigate == null ? void 0 : navigate(redirect));
      } else if ("error" in result) {
        const error2 = result.error;
        if (toastError) {
          showToastError(toast, error2, {
            defaultErrorMessage,
            errorMessageMap,
            errorMessageResolver,
            toastRenderer
          });
        }
        onError == null ? void 0 : onError(error2);
      } else {
        console.log("unable to parse api response: " + JSON.stringify(result));
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return { handleApiResponse };
}
export {
  useHandleApiResponse as default
};
